<template>
  <div>
    <div class="text-center mt-8 mb-6">
      <h2>Welcome</h2>
      <v-img
        src="@/assets/img/favicon-144x144.png"
        class="my-2"
        contain
        height="144"
      />
      <h3>{{userName}}</h3>
    </div>
    <v-col class="d-flex justify-center">
      <v-card v-show="!userAuthorized" max-width="420px" color="accent">
        <v-card-title>
          Not Authorized
        </v-card-title>
        <v-card-text class="subtitle-1">
        <b>{{ userName }}</b>
        is unauthorized for this application.
        </v-card-text>
      </v-card>
    </v-col>

    <v-overlay :value="isBusy">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      userAuthorized: true,
      isBusy: false
    }
  },
  computed: {
    ...mapState(['settings', 'isAuthenticated', 'isOnline', 'userProfile']),
    userName() {
      if (this.userProfile) {
        var userName = this.userProfile.displayName;
        return userName;
      }
      else return null;
    }
  },
  async created() {
    try {
      this.isBusy = true;
    }
    finally {
      this.isBusy = false;
    }
  }, 
  methods: {
    ...mapActions(['loadFarmSettingsFromServer']),
    gotoSettings() {
      this.$router.replace({ name: 'Settings'});
    }
  }
}
</script>